<template>
    <div
        v-if="isShowModal"
        :style="componentStyles"
        class="o-tiles-modal"
    >
        <div class="tiles-modal-container">
            <div class="tiles-modal-wrapper">
                <div class="tiles-modal-contacts">
                    <div
                        v-if="icon"
                        class="tiles-modal-logo"
                    >
                        <img
                            :src="icon"
                            class="tiles-modal-logo-image"
                        >
                    </div>
                    <div class="tiles-modal-contacts-wrapper">
                        <span
                            class="tiles-modal-contacts-title"
                        >
                            {{"ui.popup.time" | translate}}
                        </span>

                        <AWorkingHours :item="item"/>

                        <span
                            v-if="phone"
                            class="tiles-modal-contacts-title"
                        >
                            {{"ui.popup.telephone" | translate}}
                        </span>
                        <span
                            v-if="phone"
                            class="tiles-modal-contacts-text"
                        >
                            {{ phone }}
                        </span>
                        <span
                            v-if="distance"
                            class="tiles-modal-contacts-title"
                        >
                            {{"ui.popup.distance" | translate}}
                        </span>
                        <span
                            v-if="distance"
                            class="tiles-modal-contacts-text"
                        >
                            {{ distance }}m
                        </span>
                    </div>
                </div>
                <div class="tiles-modal-info">
                    <div class="tiles-modal-info-header">
                        <span class="tiles-modal-info-title">
                            {{ name }}
                        </span>
                        <div 
                            v-if="floorInfo"
                            class="tiles-modal-floor-info"
                        >
                            <AFloorInfo
                                :view="view"
                                :text="floorInfo"
                            />
                        </div>
                    </div>
                    <div class="tiles-modal-info-container">
                        <div
                            v-if="temporarilyClosedMessage"
                            class="tiles-modal-info-temporarily-closed-message"
                            v-html="temporarilyClosedMessage"
                        />
                        <div
                            class="tiles-modal-info-content"
                            v-html="content"
                        />
                        <div
                            v-if="brands.length"
                            class="tiles-modal-info-block"
                        >
                            <div class="tiles-modal-info-subtitle">
                                {{ 'Brand' | translate }}
                            </div>
                            <span
                                class="tiles-modal-info-item"
                                v-for="(catId, index) in brands"
                                :key="catId"
                            >
                                {{ t( getListItem(catId), 'name') }}
                                {{ getMarkBrands(index) }}
                            </span>
                        </div>
                        <div
                            v-if="categories.length"
                            class="tiles-modal-info-block"
                        >
                            <div class="tiles-modal-info-subtitle">
                                {{ 'Categories' | translate }}
                            </div>
                            <span
                                class="tiles-modal-info-item"
                                v-for="(catId, index) in categories"
                                :key="catId"
                            >
                                {{ t( getListItem(catId), 'name') }}
                                {{ getMarkCategories(index) }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <ONavButtonsBlock :id="itemId"/>
            <button
                type="button"
                class="tiles-modal-close-button"
                @click="closeModal"
            />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import AFloorInfo from '../../atoms/a-floor-info';
import ONavButtonsBlock from '../../organisms/o-nav-buttons-block';
import { EVENTS } from "@/utils/constants/bus-events-constants";
import {
    EASY,
    FAST
} from "@/components/organisms/o-tiles-grid-with-scroll/constants";
import AWorkingHours from "@/components/atoms/a-working-hours/a-working-hours";

export default {
    name: "OTilesModal",
    data() {
        return {
            isShowModal: false,
            itemId: null,
            view: ''
        }
    },
    components: {
        AWorkingHours,
        AFloorInfo,
        ONavButtonsBlock
    },
    computed: {
        ...mapGetters([
            't',
            'getMap',
            'getObject',
            'getListItem',
            'getMapConfigProp'
        ]),
        currentWeekDayNumber() {
            return new Date().getDay();
        },
        commonConfigStyles() {
            return this.getMapConfigProp('components.OTilesModal.styles') || {};
        },
        viewConfigStyles() {
            return this.getMapConfigProp(`views.${this.view}.mainFrame.OTilesGridWithScroll.params.OTilesModal.styles`) || {};
        },
        componentStyles() {
            return {
                ...this.commonConfigStyles,
                ...this.viewConfigStyles
            }
        },
        item() {
            return this.getObject(this.itemId);
        },
        icon() {
            return this.item.files.icon || '';
        },
        floorInfo() {
            return this.t(this.item, 'floor') || '';
        },
        workingHours() {
            const openingHoursMode = this.item.meta.otg_use_opening_hours;

            //Store hours
            const storeOpeningHours = this.item.meta.working_hours_nb;
            if(openingHoursMode === 1 && Array.isArray(storeOpeningHours)){
                return storeOpeningHours.map((item, index) => (
                    {
                        weekDayNumber: item.openDay,
                        info: item.closed ?
                            `${item.openDayName}  Stengt` :
                            `${item.openDayName}  ${item.openPeriods[0]?.openTime} - ${item.openPeriods[0]?.closeTime}`
                    }
                ));
            }

            //Center hours
            const centerOpeningHours = this.getMap.meta.otg_opening_hours;
            if(openingHoursMode === 0 && Array.isArray(centerOpeningHours)){
                return centerOpeningHours.map((item, index) => {

                    return {
                        weekDayNumber: item.openDay,
                        info: item.closed ?
                            `${item.openDayName}  Stengt` :
                            `${item.openDayName}  ${item.openPeriods[0]?.openTime} - ${item.openPeriods[0]?.closeTime}`
                    };

                });
            }

            return [];
        },
        temporarilyClosedMessage(){
            const openingHoursMode = this.item.meta.otg_use_opening_hours;
            return openingHoursMode === 2 ? this.item.meta.otg_temporarily_closed_message : '';
        },

        phone() {
            return this.t(this.item, 'phone') || '';
        },
        distance() {
            return this.t(this.item, "distance") || '';
        },
        name() {
            return this.t(this.item, "name") || '';
        },
        content() {
            return this.t(this.item, 'short_description', '') + this.t(this.item, 'content', '');
        },
        brands() {
            return this.item.lists.brands ?? [];
        },
        categories() {
            return this.item.lists.categories ?? [];
        }
    },
    methods: {
        initListeners() {
            this.$bus.$on(EVENTS.MODALS.INIT_TILES_MODAL, this.initModal);
            this.$bus.$on(EVENTS.MODALS.OFF_MODAL, this.closeModal);
        },
        removeListeners() {
            this.$bus.$off(EVENTS.MODALS.INIT_TILES_MODAL, this.initModal);
            this.$bus.$off(EVENTS.MODALS.OFF_MODAL, this.closeModal);
        },
        showModal() {
            this.isShowModal = true;
        },
        closeModal() {
            this.isShowModal = false;
        },
        initModal(id, view) {
            this.view = view;
            this.itemId = id;
            this.showModal();
        },
        getMarkBrands(index) {
            return index < this.brands.length - 1 ? '/' : '';
        },
        getMarkCategories(index) {
            return index < this.categories.length - 1 ? '/' : '';
        }
    },
    mounted() {
        this.initListeners();
    },
    beforeDestroy() {
        this.removeListeners();
    },
    FAST,
    EASY
}
</script>

<style lang="scss">
@import "theme";
</style>
